import React, { Component, } from 'react';
import { BrowserRouter as Router, Route, Redirect, Routes } from 'react-router-dom';
import './App.css';

import Login from './components/pages/Login/Login';

import Godevices from './components/pages/godevice/Godevices';
import Privateroute from './components/pages/Privateroute';
import CreateDevices from './components/pages/ViewCreateEditDevice/ViewCreateEditDevices';
import CreateDistributor from './components/pages/ViewCreateEditDistributor/ViewCreateEditDistributor';
import Recordings from './components/pages/Recordings/Recordings';
import TutorialRecordings from './components/pages/TutorialRecordings/TutorialRecordings';
import NewDevices from './components/pages/NewDevices/NewDevices';
import AddDevice from './components/pages/NewDevices/AddDevices';
// import EditDevices from './components/pages/EditDevices/EditDevices';
import WorkingMaintenance from './components/pages/WorkingPage/WorkingPage';
import Devices from './components/pages/Devices/Devices';
import AddDistributor from './components/pages/AddDistributor/AddDistributor';
import DistributorsAdd from './components/pages/DistributorsAdd/DistributorsAdd';
import EditDistributor from './components/pages/AddDistributor/EditDistributor';
import EditProfile from './components/pages/AddDistributor/EditProfile';
import CustomerPage from './components/pages/CustomerPage/CustomerPage';
import CustomerDevices from './components/pages/CustomerPage/CustomerMain';
import Device6 from './components/pages/godevice/Device6';
import UploadRecording from './components/pages/Recordings/UploadRecordingDistributor';
import Device5 from './components/pages/Devices5/Device5';
import SoftwareUpdate from './components/pages/SoftwareUpdate/SoftwareUpdate';
import NewSoftwareUpdate from './components/pages/SoftwareUpdate/NewSoftwareUpdate';
import EditSoftwareUpdate from './components/pages/SoftwareUpdate/EditSoftwareUpdate';
import Loader from './components/pages/Loader/Loader';
import NewSoftwareAnnouncement from './components/pages/SoftwareUpdate/NewSoftwareAnnouncement';
import EditSoftwareAnnouncement from './components/pages/SoftwareUpdate/EditSoftwareAnnouncement';
import EditRecordingDistributor from './components/pages/Recordings/EditRecordingDistributor';
import UploadRecordingCustomer from './components/pages/Recordings/UploadRecordingCustomer';
import EditRecordingCustomer from './components/pages/Recordings/EditRecordingCustomer';
import UploadNewTutorialRecording from './components/pages/TutorialRecordings/UploadNewTutorialRecording';
import EditTutorialRecordings from './components/pages/TutorialRecordings/EditTutorialRecordings';
import AddTutorialCategory from './components/pages/TutorialRecordings/AddTutorialCategory';
import EditTutorialCategory from './components/pages/TutorialRecordings/EditTutorialCategory';
import Announcements from './components/pages/Announcements/Announcements';
import CustomerPage6 from './components/pages/CustomerPage/CustomerPage6';
import CustomerPage5 from './components/pages/CustomerPage/CustomerPage5';
import EditNewTutorialRecording from './components/pages/TutorialRecordings/EditNewTutorialRecording';
import SoftwareAnnouncement from './components/pages/SoftwareAnnouncements/softwareAnnouncement';
import TechSupport from './components/pages/TechSupport/TechSupport';
import EditTechSupport from './components/pages/TechSupport/EditTechSupport';
import AddTechSupport from './components/pages/TechSupport/AddTechSupport';
import AllCustomerPage from './components/pages/CustomerPage/AllCustomerPage';
import CustomerModule from './components/pages/CustomerModule/CustomerModule';
import UpdatePassword from './components/pages/CustomerModule/UpdatePassword';
import CapnoGoDevices from './components/pages/godevice/CapnoGoDevices';
import DistributorDashboard from './components/pages/DistributorDashboard/DistributorDashboard';
import ManageCustomers from './components/pages/DistributorDashboard/ManageCustomers';
import APIIntegration from './components/pages/APIIntegration/APIIntegration';
import MiniCart from './components/pages/MiniCart/MiniCart';
import Home from './components/pages/home/Home';
import DistributorDiscount from './components/pages/DistributorDiscount/DistributorDiscount';
import SiteSettings from './components/pages/SiteSettings/SiteSettings';
import DistributorProducts from './components/pages/DistributorProducts/DistributorProducts';
import CapnoUsersAdmin from './components/pages/AdminDashboard/CapnoUsersAdmin';
import CapnoGoTickets from './components/pages/AdminDashboard/CapnoGoTickets';
import HelpVideos from './components/pages/HelpContent/HelpVideos';
import HelpFaqs from './components/pages/HelpContent/HelpFaqs';
import NewsReport from './components/pages/NewsReport/NewsReport';



class App extends Component {
 
	render() {
		return (
			<Router>
				<div>
					<Routes>

						<Route path="" element={<Privateroute />}>

							<Route path="/" element={<Home />} />
							<Route path="/distributor-dashboard" element={<DistributorDashboard />} />
							<Route path="/manage-customers" element={<ManageCustomers />} />
							<Route path="/api-integration" element={<APIIntegration />} />
							<Route path="/mini-cart" element={<MiniCart />} />
							<Route path="/seven/devices" element={<Godevices />} />
							<Route path="/capno-go/devices" element={<CapnoGoDevices />} />
							<Route path="/customers" element={<CustomerDevices />} />
							<Route path="/create-devices" element={<CreateDevices />} />
							<Route path="/create-devices/new-device" element={<NewDevices />} />
							<Route path="/create-distributor" element={<CreateDistributor />} />
							<Route path="/recordings" element={<Recordings />} />
							<Route path="/edit-recording-distributor" element={<EditRecordingDistributor />} />
							<Route path="/edit-recording-customer" element={<EditRecordingCustomer />} />
							<Route path="/upload-recording-customer" element={<UploadRecordingCustomer />} />
							<Route path="/upload-recording-customer/:id" element={<UploadRecordingCustomer />} />
							<Route path="/tutorial-recordings" element={<TutorialRecordings />} />
							<Route path="/upload-tutorial-recordings" element={<UploadNewTutorialRecording />} />
							<Route path="/upload-tutorial-recordings/:id" element={<UploadNewTutorialRecording />} />
							<Route path="/edit-tutorial-recordings" element={<EditTutorialRecordings />} />
							<Route path="/add-tutorial-category" element={<AddTutorialCategory />} />
							<Route path="/add-tutorial-category/:id" element={<AddTutorialCategory />} />
							<Route path="/edit-tutorial-category" element={<EditTutorialCategory />} />
							<Route path="/devices" element={<Devices />} />
							<Route path="/add-device" element={<AddDevice />} />
							<Route path="/go-customer" element={<CustomerPage />} />
							<Route path="/device-all-customer" element={<AllCustomerPage />} />
							<Route path="/device6-customer" element={<CustomerPage6 />} />
							<Route path="/device5-customer" element={<CustomerPage5 />} />
							<Route path="/maintenance" element={<WorkingMaintenance />} />
							<Route path="/six/devices" element={<Device6 />} />
							<Route path="/five/devices" element={<Device5 />} />
							<Route path="/upload-recording" element={<UploadRecording />} />
							<Route path="/upload-recording/:id" element={<UploadRecording />} />
							<Route path="/software-update" element={<SoftwareUpdate />} />
							<Route path="/software-announcement" element={<SoftwareAnnouncement />} />
							<Route path="/new-software" element={<NewSoftwareUpdate />} />
							<Route path="/edit-software/:id" element={<NewSoftwareUpdate />} />
							<Route path="/edit-software" element={<EditSoftwareUpdate />} />
							<Route path="/new-software-announcement" element={<NewSoftwareAnnouncement />} />
							<Route path="/new-software-announcement/:id" element={<NewSoftwareAnnouncement />} />
							<Route path="/edit-software-announcement" element={<EditSoftwareAnnouncement />} />
							<Route path="/announcements" element={<Announcements />} />

							{/* <Route path="/edit-device" element={<EditDevices />} /> */}
							<Route path="/distributors" element={<DistributorsAdd />} />
							<Route path="/capno-go-user" element={<CustomerModule />} />
							<Route path="/tech-support" element={<AddTechSupport />} />
							<Route path="/maintenance" element={<WorkingMaintenance />} />
							<Route path="/maintenance0" element={<WorkingMaintenance />} />
							<Route path="/maintenance1" element={<WorkingMaintenance />} />
							<Route path="/maintenance2" element={<WorkingMaintenance />} />
							<Route path="/maintenance3" element={<WorkingMaintenance />} />
							<Route path="/maintenance4" element={<WorkingMaintenance />} />
							<Route path="/maintenance5" element={<WorkingMaintenance />} />
							<Route path="/maintenance6" element={<WorkingMaintenance />} />
							<Route path="/maintenance7" element={<WorkingMaintenance />} />
							<Route path="/add-distributor" element={<AddDistributor />} />
							<Route path="/add/tech-support" element={<TechSupport />} />
							<Route path="/edit/distributor/:id" element={<EditDistributor />} />
							<Route path="/edit/profile/:id" element={<EditProfile />} />
							<Route path="/edit/tech-support/:id" element={<EditTechSupport />} />
							<Route path="/distributor/:distributor_id/discounts" element={<DistributorDiscount />} />
							<Route path="/distributor/:distributor_id/site-settings" element={<SiteSettings />} />
							<Route path="/distributor-products" element={<DistributorProducts />} />
							<Route path="/admin/capnogo-users" element={<CapnoUsersAdmin />} />
							<Route path="/admin/capnogo-tickets" element={<CapnoGoTickets />} />
							<Route path="/help-videos" element={<HelpVideos />} />
							<Route path="/help-faqs" element={<HelpFaqs />} />
							<Route path="/news-reports" element={<NewsReport />} />



						</Route>
						<Route path="/login" element={<Login />} />
						<Route path="/update-password" element={<UpdatePassword />} />

					</Routes>
				</div>
			</Router>
		);
	}
}

export default App;
